import React, { useState } from 'react';
import Layout from '../components/Layout';

function CreateSRN({ user, onLogout }) {
  const [stnQRCode, setStnQRCode] = useState('');
  const [stnDetails, setStnDetails] = useState(null);

  const handleScanQR = (e) => {
    e.preventDefault();
    // TODO: Fetch STN details from backend using QR code
    setStnDetails({
      stn_id: 'STN-12345',
      source: 'Warehouse',
      destination: 'TRC',
      devices: [
        { code: 'DEV001', sku: 'iPhone 12' },
        { code: 'DEV002', sku: 'Samsung S21' }
      ]
    });
  };

  const handleReceive = () => {
    // TODO: Create SRN and update inventory
    alert('SRN creation will be implemented');
  };

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Create Stock Receipt Note (SRN)</h1>
          <p className="text-gray-600 mt-2">Scan STN QR code to receive stock</p>
        </div>

        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <h2 className="text-xl font-semibold mb-4">Scan STN QR Code</h2>
          
          <form onSubmit={handleScanQR} className="flex gap-2">
            <input
              type="text"
              value={stnQRCode}
              onChange={(e) => setStnQRCode(e.target.value)}
              placeholder="Scan STN QR code"
              className="flex-1 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button
              type="submit"
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
              Scan
            </button>
          </form>
        </div>

        {/* STN Details */}
        {stnDetails && (
          <div className="bg-white rounded-lg shadow p-6 mb-6">
            <h2 className="text-xl font-semibold mb-4">STN Details</h2>
            
            <div className="mb-4">
              <p className="text-sm text-gray-600">STN ID</p>
              <p className="font-semibold">{stnDetails.stn_id}</p>
            </div>

            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <p className="text-sm text-gray-600">Source</p>
                <p className="font-semibold">{stnDetails.source}</p>
              </div>
              <div>
                <p className="text-sm text-gray-600">Destination</p>
                <p className="font-semibold">{stnDetails.destination}</p>
              </div>
            </div>

            <div className="mb-4">
              <h3 className="font-semibold mb-2">Devices ({stnDetails.devices.length})</h3>
              <div className="space-y-2">
                {stnDetails.devices.map((device, index) => (
                  <div key={index} className="p-3 bg-gray-50 rounded">
                    <p className="font-medium">{device.code}</p>
                    <p className="text-sm text-gray-600">{device.sku}</p>
                  </div>
                ))}
              </div>
            </div>

            <button
              onClick={handleReceive}
              className="w-full px-4 py-3 bg-green-600 text-white rounded-md hover:bg-green-700 font-semibold"
            >
              Receive Stock & Create SRN
            </button>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default CreateSRN;
